import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/**
 * Logs `ProductProfileButtonClick` as the reader follows the product to its
 * brand's profile, with the payload the legacy profile button sent.
 */
export const useTrackProductProfileClick = () => {
    const tracker = useTracker();
    return useCallback(() => {
        void tracker.log('ProductProfileButtonClick', {
            url: new URL(window.location.href),
            targetTracker: ['archiproTracker', 'ga4Tracker'],
        });
    }, [tracker]);
};
